import React from 'react';

const Modal = React.memo(function ({ children, animated, render}) {
    if (!render) return
    return (
        <div className={`modal ${animated ? "modal-animated" : ""} modal--opened`}>
            <div className="modal__overlay"></div>
            <div className="modal__wrapper">
                {children}
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    return prevProps.render !== nextProps.render
})
export default Modal;
